const getCookieObject = () => {
  const cookieArray = document.cookie.split(';');

  const cookieObject = cookieArray.reduce((cookieObject, cookieString) => {
    const [name, ...value] = cookieString.split('=');
    const nameTrimmed = name.trim();

    return {
      ...cookieObject,
      [nameTrimmed]: decodeURIComponent(value),
    };
  }, {});

  return cookieObject;
};

export const getCookieByName = (name) => {
  const cookieObject = getCookieObject();

  if (cookieObject.hasOwnProperty(name)) {
    return cookieObject[name];
  }
  return null;
};

export const setCookie = (name, value) => {
  // adds cookie, does not override other cookies
  document.cookie = `${name}=${value};`;
};

export const isFunctionalCookiesAllowed = () => {
  const cookiesOptions = getCookieByName('OptanonConsent');

  if (!!cookiesOptions && cookiesOptions.includes("C0003:1")) {
    return true;
  }
  return false;
};